export default class PreSelection extends Phaser.State {

    preload() {
        this.game.stage.backgroundColor = '#7c0410';
    }

    create() {
        this._attachDOMEvents()
    }

    _attachDOMEvents(){
        this.game.paused = true;
        // Enable pre game selection modal buttons
        const gameSelectModal = document.getElementById('game-select-modal');
        const doggo1 = gameSelectModal.querySelector('[doggo-1-button]');
        const doggo2 = gameSelectModal.querySelector('[doggo-2-button]');
        const doggo3 = gameSelectModal.querySelector('[doggo-3-button]');
        doggo1.addEventListener('click', (e) => {
            this.game.paused = false;
            this.game.dogType = "dog-yellow";
            this.state.start('Play');
            gameSelectModal.classList.remove('is-active');
        });
        doggo2.addEventListener('click', (e) => {
            this.game.paused = false;
            this.game.dogType = "doggo";
            this.state.start('Play');
            gameSelectModal.classList.remove('is-active');
        });
        doggo3.addEventListener('click', (e) => {
            this.game.paused = false;
            this.game.dogType = "dog-orange";
            this.state.start('Play');
            gameSelectModal.classList.remove('is-active');
            console.log(this.game.dogType)
        });

        // Activate game select modal
        gameSelectModal.classList.add('is-active');
    }

}



// WEBPACK FOOTER //
// ./js/states/preselection.js